import React, {ChangeEvent, useEffect, useState} from "react";
import {Disclosure, Transition} from "@headlessui/react";
import {ReactComponent as Down} from "../../../../../../assets/svg/solobuilder/dropdown-down.svg";
import {ReactComponent as Up} from "../../../../../../assets/svg/solobuilder/dropdown-up.svg";
import {ReactComponent as Delete} from "../../../../../../assets/svg/delete.svg";
import {ReactComponent as Code} from "../../../../../../assets/svg/solobuilder/code.svg";
import EditorIcon from "../../../../../../assets/svg/editorIcon.svg";
import {EditorPanel} from "../EditorPanel";
import {myRedoStack, myUndoStack} from "../../stack/Stack";
import {REDO, UNDO} from "../../../../../../stateManager/store/formCreation_v2/types";
import {useDispatch, useSelector} from "react-redux";
import {pushFormActionStack} from "../../../../../../stateManager/store/formCreation_v2/actions";
import {AppState} from "../../../../../../stateManager/store";
import { Wrapper } from "../Panel";
import { Checkbox } from "../layout-components/helpers/constants";

const SegmentsExpansionPanel = (props: any) => {

    const ENTER_SEGMENT_LABEL = "Enter segment label";
    const ENTER_SEGMENT_ID = "Enter segment id";
    const ENTER_ICON_URL = "Enter icon url";
    const {
        selectedElementId, setSegmentLabel, ErrMessage, setErrMessage, segmentLabel,
        setSegmentFields, segmentFields, isCheckedIn, properties, functionsdef,
        handleChange, removeSegment, editorContext, setEditorContext, openCodeEditorModal, propsSegments
    } = props;
    const dispatch = useDispatch();
    const state = useSelector((state: AppState) => state)
    const [ oldValue, setOldValue ] = useState<any>(null);
    const [ changingState, setChangingState ] = useState(false);
    const [idUniqueError, setIdUniqueError] = useState<any>(null);
    const [onChangeId, setOnchangeId] = useState<any>(null);

    const setEditorVisibility = (visibility: boolean) => {
        setEditorContext((prevState: any) => ({...prevState, visibility}))
    }

    useEffect(() => {
        const previousValue = props.segments
        if (previousValue) {
            setOldValue(JSON.stringify(previousValue))
        }
    }, [ changingState, props?.segments ])

    const handleSegmentChanges = async (data: any) => {
        let uniqueId = propsSegments && propsSegments?.filter((item: any) => item?.segmentFields?.id === data.value) || []
        if (uniqueId.length === 0) {
            setIdUniqueError(null)
            myUndoStack.push({
                id: selectedElementId,
                fields: [],
                label: "",
                properties: {},
                type: "",
                value: JSON.parse(oldValue)
            });
            myRedoStack.clear();
            dispatch(pushFormActionStack({
                undo: () => {
                    const poppedElement = myUndoStack.pop();
                    const lastSegment = poppedElement?.value;
                    if (poppedElement) {
                        myRedoStack.push({...poppedElement, id: selectedElementId, value: lastSegment})
                        dispatch({
                            type: UNDO,
                            actionPointer: state.actionPointer - 1,
                        })
                        let tempSegments = props.segments
                        let path = tempSegments[ data.idx ].segmentFields
                        path[ data.type ] = lastSegment[ data.idx ].segmentFields[ data.type ]
                        handleChange("properties.config.segments", tempSegments)
                    }
                },
                redo: () => {
                    const poppedElement = myRedoStack.pop();
                    if (poppedElement) {
                        myUndoStack.push({...poppedElement})
                        dispatch({
                            type: REDO,
                            actionPointer: state.actionPointer + 1,
                        })
                        let tempSegments = poppedElement?.value
                        let path = tempSegments[ data.idx ].segmentFields
                        path[ data.type ] = data.value
                        handleChange("properties.config.segments", tempSegments)
                    }
                }
            }))
            let tempSegments = props?.segments;
            let path = tempSegments[ data?.idx ]?.segmentFields;
            path[ data?.type ] = data?.value;
            handleChange("properties.config.segments", tempSegments)
        } else {
            setIdUniqueError("Id already exists")
        }
    }

    return (
        <div className="w-full">
            <div className="w-full bg-transparent">
                {
                    props.tabAddMode &&
                    <div className="flex flex-col">
                        <div className="panel-div">
                            <div className="panel-label">Section label</div>
                            <input
                                value={segmentLabel}
                                className="panel-input" placeholder={ENTER_SEGMENT_LABEL}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => {setSegmentLabel(e.target.value); setErrMessage("")}}
                            >
                            </input>
                        </div>
                        <div className="panel-div">
                            <div className="panel-label">Id</div>
                            <input
                                value={segmentFields.id || ""}
                                className="panel-input" placeholder={ENTER_SEGMENT_ID}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => {setSegmentFields({...segmentFields, id: e.target.value}); setErrMessage("")}}
                            >
                            </input>
                        </div>
                        {properties?.segmentType !== "icon" && <div className="panel-div">
                            <div className="panel-label">Label</div>
                            <input
                                value={segmentFields?.label || ""}
                                className="panel-input" placeholder={ENTER_SEGMENT_LABEL}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => {setSegmentFields({...segmentFields, label: e.target.value}); setErrMessage("")}}
                            ></input>
                        </div>}
                        <Checkbox
                            key="Seg_visble_check"
                            id="Seg_visble_check"
                            value={segmentFields ? segmentFields?.visible : true}
                            label="Visible"
                            onChange={() => {
                                setSegmentFields({ ...segmentFields, visible: !segmentFields?.visible })
                            }}
                        />
                        <Checkbox
                            key="Seg_disable_check"
                            id="Seg_disable_check"
                            value={(segmentFields && segmentFields?.disable) || false}
                            label="Disable"
                            onChange={() => {
                                setSegmentFields({ ...segmentFields, disable: !segmentFields?.disable })
                            }}
                        />
                        {properties?.segmentType !== "text" && <div className="panel-div">
                            <div className="panel-label">Selected icon</div>
                            <input
                                value={segmentFields?.selectedIconUrl || ""}
                                className="panel-input" placeholder={ENTER_ICON_URL}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setSegmentFields({...segmentFields, selectedIconUrl: e.target.value})}
                            ></input>
                        </div>}
                        {properties?.segmentType !== "text" && <div className="panel-div">
                            <div className="panel-label">Unselected icon</div>
                            <input
                                value={segmentFields?.unSelectedIconUrl || ""}
                                className="panel-input" placeholder={ENTER_ICON_URL}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setSegmentFields({...segmentFields, unSelectedIconUrl: e.target.value})}
                            ></input>
                        </div>}
                        {ErrMessage && (
                            <p
                                data-test-id="validation_error_message"
                                style={{color: "red", textAlign: "left", marginTop: "10px" }}
                            >
                                {ErrMessage}
                            </p>
                        )}
                    </div>
                }
                {
                    props.segments && props.segments?.length > 0 && props.segments.map((items: any, i: number) => {
                        let segmentFields = items?.segmentFields
                        return (
                            <div key={i} >
                                <Disclosure>
                                    {({open}) => (
                                        <>
                                            <Disclosure.Button style={{borderRadius: "4px", height:"28px", marginTop:"10px", background: "#EFF0F4"}}
                                                className="flex items-center p-2 w-full marginTop_seg justify-between rounded-sm  text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span style={{fontWeight:600, fontSize:"12px", color:"#505F7B"}}>{items?.segmentLabel}</span>
                                                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                                    {props?.segments?.length > 1 && <Delete style={{cursor: "pointer"}} height="15px" onClick={(e: any) => removeSegment(e, items)} />}
                                                    <div>
                                                        {
                                                            open ? <Up></Up> : <Down></Down>
                                                        }
                                                    </div>
                                                </div>
                                            </Disclosure.Button>
                                            <Transition
                                                show={open}
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <div style={{border: "1.5px solid #EFF0F4", borderTop: "none", padding: "0px 5px 9px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px"}}>
                                                    <Disclosure.Panel static>
                                                        <div style={{display: "flex", flexDirection: "column"}}>
                                                            <div className="panel-div">
                                                                <div className="panel-label">Id</div>
                                                                <div style={{display: "flex", flexDirection: "column", width: 170}}>
                                                                    <input
                                                                        value={segmentFields?.id}
                                                                        className="panel-input"
                                                                        placeholder={ENTER_SEGMENT_ID}
                                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                            setChangingState(changingState => !changingState);
                                                                            setOnchangeId(i); handleSegmentChanges({type: "id", value: e.target.value, idx: i});
                                                                        }}
                                                                    >
                                                                    </input>
                                                                    {(idUniqueError && onChangeId === i) && <div style={{color: "red", fontSize: "10px"}}>{idUniqueError}</div>}
                                                                </div>
                                                            </div>
                                                            {properties?.segmentType !== "icon" && <div className="panel-div">
                                                                <div className="panel-label">Label</div>
                                                                <input
                                                                    value={segmentFields?.label}
                                                                    className="panel-input" placeholder={ENTER_SEGMENT_LABEL}
                                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {setChangingState(changingState => !changingState); handleSegmentChanges({type: "label", value: e.target.value, idx: i})}}
                                                                ></input>
                                                            </div>}
                                                            <Checkbox
                                                                key="Seg_visible"
                                                                id="Seg_visible"
                                                                value={segmentFields?.visible}
                                                                label="Visible"
                                                                onChange={() => {
                                                                        setChangingState(changingState => !changingState);
                                                                        handleSegmentChanges({type: "visible", value: !segmentFields?.visible, idx: i})
                                                                }}
                                                            />
                                                            <Checkbox
                                                                key="Seg_disable"
                                                                id="Seg_disable"
                                                                value={segmentFields?.disable}
                                                                label="Disable"
                                                                onChange={() => {
                                                                        setChangingState(changingState => !changingState);
                                                                        handleSegmentChanges({type: "disable", value: !segmentFields?.disable, idx: i})
                                                                }}
                                                            />
                                                            <Wrapper key="OnSegmentLoad">
                                                                <p className="panel-label">On load</p>
                                                                <p
                                                                    className="flex items-center font-medium rounded-md cursor-pointer"
                                                                    style={{
                                                                        color: "#0466C8",
                                                                        backgroundColor: "rgba(4, 102, 200, 0.1)",
                                                                        height: "28px",
                                                                        width: "170px",
                                                                        padding: "5px"
                                                                    }}
                                                                    onClick={async () => {
                                                                        await openCodeEditorModal()
                                                                        setEditorContext({
                                                                            visibility: true,
                                                                            source: items.onload ? items.onload : `async function main(selectedSegment) {\n      // Start of editable area\n      \n      // End of editable area\n    }`,
                                                                            where: `${items.key}.segments.onload`,
                                                                        })
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            width: "100%"
                                                                        }}
                                                                    >
                                                                        <span>On segment load</span>
                                                                        <img src={EditorIcon} alt="editorIcon" />
                                                                    </div>
                                                                </p>
                                                            </Wrapper>
                                                            {properties?.segmentType !== "text" && <div className="panel-div">
                                                                <div className="panel-label">Selected icon</div>
                                                                <input
                                                                    value={segmentFields?.selectedIconUrl}
                                                                    className="panel-input" placeholder={ENTER_ICON_URL}
                                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                        setChangingState(changingState => !changingState);
                                                                        handleSegmentChanges({type: "selectedIconUrl", value: e.target.value, idx: i})
                                                                    }}
                                                                ></input>
                                                            </div>}
                                                            {properties?.segmentType !== "text" && <div className="panel-div">
                                                                <div className="panel-label">Unselected icon</div>
                                                                <input
                                                                    value={segmentFields?.unSelectedIconUrl}
                                                                    className="panel-input"
                                                                    placeholder={ENTER_ICON_URL}
                                                                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                                        setChangingState(changingState => !changingState);
                                                                        handleSegmentChanges({type: "unSelectedIconUrl", value: e.target.value, idx: i})
                                                                    }}
                                                                ></input>
                                                            </div>}
                                                        </div>
                                                    </Disclosure.Panel>
                                                </div>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        )
                    })
                }
            </div>
            {
                editorContext.visibility ? (
                    <EditorPanel
                        customdef={functionsdef}
                        isCheckedIn={isCheckedIn}
                        close={() => setEditorVisibility(false)}
                        editorContext={editorContext}
                        type={"inline"}
                    />
                ) : null
            }
        </div>
    )
}

export default SegmentsExpansionPanel;